import React, { Component } from "react"

import { enumValueSort } from "shared/search/containers/Filter/Filters"
import { enumGenericFilter } from "shared/search/containers/Filter/FilterCreators"

export class EventParticipantTypeFilter extends Component {
    static get defaultProps() {
        const participantFields = [
            DjangIO.app.models.QuorumDataType.user.value,
            DjangIO.app.models.QuorumDataType.team.value,
            DjangIO.app.models.QuorumDataType.person.value,
            DjangIO.app.models.QuorumDataType.supporter.value,
            DjangIO.app.models.QuorumDataType.public_organization.value,
        ]

        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "EventParticipantTypeFilter",
            filterKey: "participant_type__in",
            enumItems: DjangIO.app.models.QuorumDataType.region_supported_items().filter((item) =>
                participantFields.includes(item.value),
            ),
            sortBy: enumValueSort,
            displayKey: "plural",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
